const localDateTimeFormatMap = {
    zh_TW: {
        language: 'zh-TW',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    },
} as const;

type LocaleKey = keyof typeof localDateTimeFormatMap;

export const convertDate = (
    date?: number,
    options?: {
        usePreciseTime?: boolean;
        locale?: LocaleKey;
    }
) => {
    if (!date) {
        return date;
    }

    const { usePreciseTime = false, locale = 'zh_TW' } = options ?? {};

    const dateObj = new Date(date * 1000);

    const dateFormatter = new Intl.DateTimeFormat(
        localDateTimeFormatMap[locale].language,
        {
            month: localDateTimeFormatMap[locale].month,
            day: localDateTimeFormatMap[locale].day,
            year: localDateTimeFormatMap[locale].year,
        }
    );

    const timeFormatter = new Intl.DateTimeFormat(
        localDateTimeFormatMap[locale].language,
        {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        }
    );

    const formattedDate = dateFormatter.format(dateObj);

    if (usePreciseTime) {
        const formattedTime = timeFormatter.format(dateObj);

        return `${formattedDate} ${formattedTime}`;
    }

    return formattedDate;
};
